// Bot Suggestions Service
// Service to provide welcome prompt suggestions from gallery data only (uses promptGalleryData.json if API fails)

import { promptGalleryService } from '../PromptGallery/services/promptGalleryService';
import { COPILOT_CONSTANTS } from '../constants';

/**
 * Get top 6 suggestions from prompt gallery (from session storage or promptGalleryData.json fallback)
 * @param category - Unused, kept for backward compatibility
 * @param maxSuggestions - Maximum number of suggestions (defaults to 5)
 * @returns Array of suggestion objects with task and questionText
 */
export const getSuggestionsByCategory = (
  category?: any,
  maxSuggestions: number = COPILOT_CONSTANTS.LIST_LIMITS.MAX_SUGGESTIONS
): Array<{task?: string, questionText: string}> => {
  // Get gallery data from session storage (or promptGalleryData.json fallback if API failed)
  const galleryData = promptGalleryService.getSuggestionsData();
  
  if (galleryData && galleryData.length > 0) {
    // Sort by rank (lower rank = higher priority) and take top suggestions
    const topRankedQuestions = [...galleryData]
      .sort((a, b) => {
        const rankA = typeof a.rank === 'number' ? a.rank : 999;
        const rankB = typeof b.rank === 'number' ? b.rank : 999;
        return rankA - rankB;
      })
      .slice(0, maxSuggestions)
      .map(item => ({ task: item?.title, questionText: item.questionText }));
    
    return topRankedQuestions;
  }
  
  // No data available yet (API still loading)
  return [];
};

/**
 * Get suggestions as JSON string
 * Uses prompt gallery data (session storage or promptGalleryData.json fallback)
 * @param category - Unused, kept for backward compatibility
 * @param maxSuggestions - Maximum number of suggestions (defaults to 5)
 * @returns JSON string representation
 */
export const getSuggestionsAsJsonString = (
  category?: any,
  maxSuggestions: number = COPILOT_CONSTANTS.LIST_LIMITS.MAX_SUGGESTIONS
): string => {
  const suggestions = getSuggestionsByCategory(category, maxSuggestions);
  return JSON.stringify(suggestions);
};

// Service object for compatibility
export const botSuggestionsService = {
  getSuggestionsByCategory,
  getSuggestionsAsJsonString
};